import React, { useState } from 'react'
import cn from 'classnames'

import { ActionButton } from '../ActionButton/ActionButton'
import { MarketTextField } from '../MarketTextField/MarketTextField'
import { CheckBox } from '../../../components/CheckBox/CheckBox'

import { numSpaces, strNumOnly } from '../../../utils/functions'
import { MARKET_MIN_AMOUNT } from '../../../utils/const'

import './OwnerFormAdd.scss'

export const OwnerFormAdd = ({
  lock,
  actionResult,
  amount,
  onChange,
  onOffer,
}) => {
  const [checked, setChecked] = useState(false)

  const onChangeAmount = e => {
    let str = e.target.value
    onChange(strNumOnly(str))
  }

  const ok = amount >= MARKET_MIN_AMOUNT

  return (
    <div
      className={
        cn(
          'owner-form-add',
          { lock },
          { error: amount && !ok },
          { label: actionResult }
        )
      }
    >
      <MarketTextField
        placeholder="AMMOUNT IN TRX"
        value={ amount }
        onChange={ onChangeAmount }
      />
      <div className="error-container">
        <span>
          MIN AMMOUNT IS { numSpaces(MARKET_MIN_AMOUNT) } TRX
        </span>
      </div>
      <ActionButton
        label="OFFER FOR SALE"
        blue
        disabled={ !checked || !ok }
        onClick={ onOffer }
      />
      <span className="space"></span>
      <CheckBox
        label="I AGREE TO PUT COOLCAT ON MARKETPLACE"
        blue
        checked={ checked }
        onChange={ () => setChecked(!checked) }
      />
      <div className="label-container">
        <span>
          { actionResult }
        </span>
      </div>
    </div>
  )
}